import * as React from 'react'
import { Link } from 'react-router-dom'

import { Box, NumberBadge, Text } from '@factorialco/deprecated-design-system'

import { OverflowContextProvider } from 'modules/core/lib/overflowContext'

import useIncidenceTypeQueryParam from 'modules/bookkeepers/hooks/useIncidenceTypeQueryParam'
import { matchSubPathByIncidenceType } from 'modules/bookkeepers/lib/incidenceTypeNavigation'

import './index.styles.css'
interface SubNavItemProps {
  path: string
  name: string
  count?: number
  fullPath: string
  parentKey: string
}

const SubNavItem = ({ path, name, count, parentKey, fullPath }: SubNavItemProps) => {
  const { incidenceType } = useIncidenceTypeQueryParam()
  const isActive = fullPath.includes(path) || matchSubPathByIncidenceType(incidenceType, parentKey)
  const ref = React.useRef(null)

  return (
    <>
      {path && name && (
        <Link to={path} className={isActive ? 'Sidebar_activeSubnavbar' : ''}>
          <Box
            flexDirection="row"
            alignItems="center"
            justifyContent="spaceBetween"
            paddingY="s6"
            paddingLeft="s24"
            paddingRight="s16"
            width="full"
          >
            <Box
              flexDirection="row"
              alignItems="center"
              justifyContent="spaceBetween"
              flexGrow
              paddingRight="s8"
              paddingLeft="s8"
              overflowX="hidden"
            >
              <Box className={'Sidebar_textWidth'}>
                <OverflowContextProvider childrenRef={ref} value={name}>
                  <Text
                    size="200"
                    color="grey000White"
                    weight={isActive ? 'semibold' : 'normal'}
                    innerRef={ref}
                    ellipsis
                  >
                    {name}
                  </Text>
                </OverflowContextProvider>
              </Box>
              <Box>{count && count > 0 ? <NumberBadge label={count} color="grey800" /> : null}</Box>
            </Box>
          </Box>
        </Link>
      )}
    </>
  )
}

export default SubNavItem
